import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { createRelease } from "../api/releasesApi";
import "./CreateReleaseModal.css";

/**
 * CreateReleaseModal
 * Form to create a new release via API 2.
 * On success, calls onSuccess() so the parent can refresh the releases list.
 */
const CreateReleaseModal = ({ show, onHide, onSuccess }) => {
    const [releaseName, setReleaseName] = useState("");
    const [createdBy, setCreatedBy] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (show) {
            setReleaseName("");
            setCreatedBy("");
            setSubmitting(false);
            setError("");
        }
    }, [show]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const name = releaseName.trim();
        const by = createdBy.trim();
        if (!name || !by) return;
        setSubmitting(true);
        setError("");
        try {
            await createRelease({ releaseName: name, createdBy: by });
            onSuccess();
            onHide();
        } catch (err) {
            setError(err?.message || "Failed to create release. Please try again.");
            setSubmitting(false);
        }
    };

    const canCreate =
        releaseName.trim().length > 0 &&
        createdBy.trim().length > 0 &&
        !submitting;

    return (
        <Modal show={show} onHide={onHide} className="create-release-modal" centered>
            <Modal.Header closeButton>
                <Modal.Title>Create Release</Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    {error && (
                        <div className="create-release-modal__error" role="alert">
                            {error}
                        </div>
                    )}
                    <Form.Group className="mb-3">
                        <Form.Label>Release name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="e.g. Q2 2026 Release"
                            value={releaseName}
                            onChange={(e) => setReleaseName(e.target.value)}
                            maxLength={256}
                            required
                            autoFocus
                        />
                        <Form.Text className="text-muted">Required, max 256 characters.</Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-0">
                        <Form.Label>Created by</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Your name or email"
                            value={createdBy}
                            onChange={(e) => setCreatedBy(e.target.value)}
                            maxLength={128}
                            required
                        />
                        <Form.Text className="text-muted">Required, max 128 characters.</Form.Text>
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide} disabled={submitting}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        type="submit"
                        disabled={!canCreate}
                        className="create-release-modal__btn-create"
                    >
                        {submitting ? "Creating…" : "Create"}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default CreateReleaseModal;
